import { reactive, readonly } from "vue";

const state = reactive({
    goodCount: 0,
    badCount: 0,
    isGoodPushed: false,
    isBadPushed: false,
    isUpdating: false,
    endpoint: "",
});
const incrementGoodCount = () => {
    state.goodCount++;
    state.isGoodPushed = true;
};
const incrementBadCount = () => {
    state.badCount++;
    state.isBadPushed = true;
};
const decrementGoodCount = () => {
    state.goodCount--;
    state.isGoodPushed = false;
};
const decrementBadCount = () => {
    state.badCount--;
    state.isBadPushed = false;
};

const setGoodCount = (count) => {
    state.goodCount = count;
};
const setBadCount = (count) => {
    state.badCount = count;
};

const setEndpoint = (endpoint) => {
    state.endpoint = endpoint;
};

const pushGoodCount = () => {
    if (state.isUpdating) {
        return;
    }
    let updateData, callback;

    if (state.isGoodPushed) {
        updateData = {
            good: -1,
        };
        callback = function () {
            // Good を Decrement
            decrementGoodCount();
            updateStateInLocalStorage(0);
        };
    } else if (state.isBadPushed) {
        updateData = {
            good: 1,
            bad: -1,
        };
        callback = function () {
            // Good を Increment
            incrementGoodCount();
            // Bad を Decrement
            decrementBadCount();
            updateStateInLocalStorage(1);
        };
    } else {
        updateData ={
            good: 1,
        };
        callback = function () {
            // Good を Increment
            incrementGoodCount();
            updateStateInLocalStorage(1);
        };
    }
    update(updateData, callback);
};
const pushBadCount = () => {
    if (state.isUpdating) {
        return;
    }
    let updateData, callback;

    if (state.isBadPushed) {
        updateData = {
            bad: -1,
        };
        callback = function () {
            // Good を Decrement
            decrementBadCount();
            updateStateInLocalStorage(0);
        }
    } else if (state.isGoodPushed) {
        updateData = {
            good: -1,
            bad: 1,
        };
        callback = function () {
            // Good を Increment
            incrementBadCount();
            // Bad を Decrement
            decrementGoodCount();
            updateStateInLocalStorage(2);
        }
    } else {
        updateData = {
            bad: 1,
        };
        callback = function () {
            // Good を Increment
            incrementBadCount();
            updateStateInLocalStorage(2);
        }
    }
    update(updateData, callback);
};

const update = (updateData, callback) => {
    state.isUpdating = true;
    axios
        .post(state.endpoint, updateData, {
            headers: {
                // "X-CSRF-TOKEN": props.csrf,
                "X-HTTP-Method-Override": "PUT",
            },
        })
        .then(() => {
            callback();
        })
        .catch(() => {})
        .finally(() => {
            state.isUpdating = false;
        });
};

const updateStateInLocalStorage = (status) => {
    switch (status) {
        case 0:
            // do nothing
            localStorage.removeItem(state.endpoint);
            break;
        case 1:
            // いいねが押されている
            localStorage.setItem(state.endpoint, 1);
            state.isGoodPushed = true
            break;
        case 2:
            // バッドが押されている
            state.isBadPushed = true
            localStorage.setItem(state.endpoint, 2);
            break;
    }
}

const setInitialState = () => {
    let status = localStorage.getItem(state.endpoint);

    switch (Number(status)) {
        case 0:
            // do nothing
            break;
        case 1:
            // いいねが押されている
            state.isGoodPushed = true;
            break;
        case 2:
            // バッドが押されている
            state.isBadPushed = true;
            break;
        default:
            console.error('Failed to get localstorage value.');
            break;
    }
}

export default {
    state,
    incrementGoodCount,
    decrementGoodCount,
    incrementBadCount,
    decrementBadCount,
    pushGoodCount,
    pushBadCount,
    setGoodCount,
    setBadCount,
    setEndpoint,
    setInitialState,
};
